import PropTypes from 'prop-types'
import React, { useMemo } from 'react'
import Content from './Content'
import Header from './Header'
import ImagesText from './ImagesText'
import OtherNeeds from './OtherNeeds'
import PromoBanner from './PromoBanner'
import { useCms } from '../cms/CmsContext'

const ContentHeader = ({ show, toggleDetails, detailsActive }) => {
  const {
    pageContent: {
      backgroundImageDesktop,
      backgroundImageMobile,
      pageHeading,
      preambleDesktop,
      preambleMobile,
      uspsDesktop,
      uspsMobile,
      imagesDesktop,
      imagesMobile,
      imagesText,
      otherNeeds,
      showPromotionBanner,
      promotionBannerText,
      promotionBannerColor,
      promotionBannerTextColor,
    },
  } = useCms()

  const { showPromo, showOtherNeeds, compact } = useMemo(() => {
    const promo = showPromotionBanner && promotionBannerText

    return {
      showPromo: promo,
      showOtherNeeds: otherNeeds?.length > 0,
      compact: !backgroundImageMobile && !backgroundImageDesktop && !promo,
    }
  }, [
    showPromotionBanner,
    promotionBannerText,
    otherNeeds,
    backgroundImageMobile,
    backgroundImageDesktop,
  ])

  if (!show) return null
  return (
    <>
      <Header
        mobileBackground={backgroundImageMobile}
        desktopBackground={backgroundImageDesktop}
        showPromo={showPromo}
      >
        <Content
          pageHeading={pageHeading}
          preambleDesktop={preambleDesktop}
          preambleMobile={preambleMobile}
          uspsDesktop={uspsDesktop}
          uspsMobile={uspsMobile}
          imagesDesktop={imagesDesktop}
          imagesMobile={imagesMobile}
          compact={compact}
        />
      </Header>
      {imagesText && (
        <ImagesText
          imagesText={imagesText}
          imagesMobile={imagesMobile}
          imagesDesktop={imagesDesktop}
        />
      )}
      {showPromo && (
        <PromoBanner
          text={promotionBannerText}
          color={promotionBannerTextColor}
          bgColor={promotionBannerColor}
        />
      )}
      {showOtherNeeds && (
        <OtherNeeds
          otherNeeds={otherNeeds[0]}
          toggleDetails={toggleDetails}
          detailsActive={detailsActive}
        />
      )}
    </>
  )
}

ContentHeader.defaultProps = {
  detailsActive: false,
  toggleDetails: null,
}

ContentHeader.propTypes = {
  show: PropTypes.bool.isRequired,
  toggleDetails: PropTypes.func,
  detailsActive: PropTypes.bool,
}

export default ContentHeader
